// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24HpR","location":"Header_location__1h1CH"};